import classNames from 'classnames';
import React from 'react';
import styles from './Pill.module.css';

export enum PillSize {
  Small = 'small',
  Medium = 'medium',
}

export enum PillColor {
  Green = 'green',
  Grey = 'grey',
  Purple = 'purple',
  Red = 'red',
  Red10 = 'red10',
  Red70 = 'red70',
  Blue = 'blue',
  Yellow = 'yellow',
  Black = 'black',
}

export type PillProps = {
  children: React.ReactNode;
  color?: PillColor;
  size?: PillSize;
  id?: string;
};

const Pill = ({
  children,
  id,
  color = PillColor.Grey,
  size = PillSize.Medium,
}: PillProps) => {
  const className = classNames(styles.container, styles[color], styles[size]);

  return (
    <div id={id} className={className}>
      {children}
    </div>
  );
};

Pill.Color = PillColor;
Pill.Size = PillSize;

export default Pill;
